import React from "react";
import EmployeeProfileTabHeader from "./EmployeeProfileTabHeader";
import EmployeeProfileSectionCard from "./EmployeeProfileSectionCard";
import EmployeeProfileEmptyState from "./EmployeeProfileEmptyState";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import AddIcon from "@mui/icons-material/Add";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import WorkIcon from "@mui/icons-material/Work";
import { getCardColor2 } from "../../../../../helpers/helpers";
import PersonCardModal from "../../../home/schedule_components/PersonCardModal";
import PersonAvatar from "../../../home/schedule_components/PersonAvatar";

function EmployeeProfileAttributesTab(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setMainRoleId(props.selectedTeamMemberData?.primary_role_id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [mainRoleId, setMainRoleId] = React.useState(
    props.selectedTeamMemberData?.primary_role_id
  );

  const handleMainRoleSelection = (event) => {
    setMainRoleId(event.target.value);
  };

  const name =
    props.selectedTeamMemberData?.first_name +
    " " +
    props.selectedTeamMemberData?.last_name;

  const returnAvatar = () => {
    return (
      <PersonAvatar
        name={name}
        bgColor={getCardColor2(mainRoleId, props.roleNames, false)}
      />
    );
  };

  const p = {
    ...props.selectedTeamMemberData,
    available_role_info: props.selectedTeamMemberData?.roles_and_role_types,
  };

  const hasRoles = props.selectedTeamMemberData.roles_and_role_types?.length > 0;
  const sortedRoles = hasRoles
    ? props.selectedTeamMemberData?.roles_and_role_types?.sort((a, b) => {
        if (a.scheduled_role_obj?.role_type_id === b.scheduled_role_obj?.role_type_id) {
          return a.scheduled_role_obj?.role_name.localeCompare(b.scheduled_role_obj?.role_name);
        }
        return a.scheduled_role_obj?.role_type_id - b.scheduled_role_obj?.role_type_id;
      })
    : [];

  return (
    <>
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <EmployeeProfileTabHeader
          icon={WorkIcon}
          title="Roles & Skills"
          subtitle="Manage roles and skill levels"
          actionLabel="Edit"
          actionIcon={EditIcon}
          onAction={handleOpen}
          actionVariant="outline"
        />

        <div className="grid grid-cols-1 gap-6">
          {/* Roles & Skills Card */}
          <div className="min-w-0">
            <EmployeeProfileSectionCard header="Roles & Skill Levels">
              {hasRoles ? (
                <div className="space-y-3">
                  {/* Table Header */}
                  <div className="grid grid-cols-12 gap-4 px-3 pb-3 border-b border-gray-200">
                    <div className="col-span-5">
                      <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">Role</span>
                    </div>
                    <div className="col-span-4">
                      <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">Skill Level</span>
                    </div>
                    <div className="col-span-3 text-right">
                      <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">Main Role</span>
                    </div>
                  </div>

                  {/* Role Items */}
                  <div className="space-y-1">
                    {sortedRoles.map((role, index) => (
                      <div key={index} className="grid grid-cols-12 gap-4 items-center py-3 rounded-lg px-3 hover:bg-gray-50 transition-colors">
                        {/* Role Name */}
                        <div className="col-span-5 flex items-center space-x-3">
                          <div
                            className={`w-4 h-4 rounded-full shadow-sm ${getCardColor2(
                              role.scheduled_role,
                              props.roleNames,
                              false
                            )}`}
                          />
                          <span className="font-medium text-gray-900">
                            {role?.scheduled_role_obj?.role_name}
                          </span>
                        </div>

                        {/* Skill Rating */}
                        <div className="col-span-4">
                          <Rating
                            name="read-only"
                            value={
                              props.proficiencyFromLMSEnabled
                                ? role?.training_proficiency_rating
                                : role?.proficiency_rating
                            }
                            readOnly
                            max={props.proficiencyStarsCount}
                            icon={<StarIcon style={{ fontSize: "20px" }} />}
                            emptyIcon={<StarBorderIcon style={{ fontSize: "20px" }} />}
                            sx={{
                              '& .MuiRating-iconFilled': {
                                color: '#f59e0b',
                              },
                              '& .MuiRating-iconEmpty': {
                                color: '#d1d5db',
                              },
                            }}
                          />
                        </div>

                        {/* Primary Role Indicator */}
                        <div className="col-span-3 flex justify-end">
                          {role?.main_role_ind === 1 ? (
                            <div className="flex items-center space-x-2">
                              <span className="text-sm font-medium text-emerald-700">Primary</span>
                              <div className="w-7 h-7 rounded-full bg-emerald-600 flex items-center justify-center shadow-sm">
                                <CheckIcon className="text-white" style={{ fontSize: "16px" }} />
                              </div>
                            </div>
                          ) : (
                            <div className="w-7 h-7 rounded-full border-2 border-gray-200 bg-white"></div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <EmployeeProfileEmptyState
                  icon={WorkIcon}
                  title="No roles assigned"
                  description="This employee hasn't been assigned to any roles yet."
                  action={
                    <button
                      onClick={handleOpen}
                      className="inline-flex items-center gap-1.5 bg-violet-600 hover:bg-violet-700 text-white px-3 py-1.5 rounded-lg text-sm font-medium transition-colors"
                    >
                      <AddIcon style={{ fontSize: "16px" }} />
                      <span>Assign Roles</span>
                    </button>
                  }
                />
              )}
            </EmployeeProfileSectionCard>
          </div>


        </div>
      </div>

      <PersonCardModal
        showTargetHours={false}
        handleClose={handleClose}
        open={open}
        p={p}
        role_names={props.roleNames}
        updatePersonInfo={props.updatePersonInfo}
        handleMainRoleSelection={handleMainRoleSelection}
        mainRoleId={mainRoleId}
        setMainRoleId={setMainRoleId}
        returnAvatar={returnAvatar}
        proficiencyStarsCount={props.proficiencyStarsCount}
        proficiencyFromLMSEnabled={props.proficiencyFromLMSEnabled}
      />
    </>
  );
}

export default EmployeeProfileAttributesTab;
